import { ApiError } from "@commerce-os/api-client";
import { Button, ErrorState, LoadingState } from "@commerce-os/ui";
import { type ErrorComponentProps, Link, useRouter } from "@tanstack/react-router";

import { describeError } from "../../app/errors";
import { useT } from "../../app/i18n";

export function NotFoundPage() {
  const { t } = useT();
  return (
    <div className="flex min-h-[60dvh] flex-col items-center justify-center gap-3 p-6 text-center">
      <h1 className="text-2xl font-semibold">{t("notFound.title")}</h1>
      <p className="text-muted-foreground">{t("notFound.body")}</p>
      <Button asChild>
        <Link to="/">{t("notFound.home")}</Link>
      </Button>
    </div>
  );
}

/** The error boundary of every route: a translated message, the request ID, and a retry. */
export function RouteErrorPage({ error }: ErrorComponentProps) {
  const { t } = useT();
  const router = useRouter();
  if (error instanceof ApiError && error.code === "FORBIDDEN") {
    return <ErrorState title={t("noAccess.title")} description={t("noAccess.body")} />;
  }
  const { message, reference } = describeError(t, error);
  return (
    <ErrorState
      title={t("states.error")}
      description={message}
      {...(reference === undefined ? {} : { reference })}
      retryLabel={t("actions.retry")}
      onRetry={() => void router.invalidate()}
    />
  );
}

export function PageLoading() {
  const { t } = useT();
  return <LoadingState label={t("states.loading")} className="min-h-[60dvh]" />;
}
